import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordMatchValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.get('password');
    const passwordrepeat = control.get('passwordrepeat');

    if (password && passwordrepeat && password.value !== passwordrepeat.value) {
      return { passwordMismatch: true };
    }
    return null;
  };
}